export default "__VITE_ASSET__CWn5kMvT__"